import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Smartphone, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { hapticImpact, isNative } from '../native';

// Replace YOUR_AFFILIATE_ID with your actual Airalo affiliate ID before launch
const AFFILIATE_BASE_URL = "https://airalo.pxf.io/c/7258037/1268485/15608";

const EsimCard = ({ destination }) => {
  const { t } = useTranslation();
  
  const handleGetEsim = () => {
    if (isNative) hapticImpact('light');
    window.open(AFFILIATE_BASE_URL, '_blank');
  };

  return (
    <Card 
      data-testid="esim-card"
      className="bg-gradient-to-br from-orange-500/10 via-red-500/5 to-orange-500/10 border-orange-400/30"
    >
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Smartphone className="w-5 h-5 text-orange-500" />
          {t('need_mobile_data')}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <p className="text-sm text-muted-foreground">
          {destination 
            ? t('esim_subtitle', { destination })
            : "Get instant eSIM data for your destination. Works on iPhone XS+ and most Android phones."
          }
        </p>
        
        <Button
          data-testid="get-esim-button"
          onClick={handleGetEsim}
          className="w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-semibold"
        >
          {t('get_esim')}
          <ExternalLink className="w-4 h-4 ml-2" />
        </Button>
        
        <p className="text-xs text-center text-muted-foreground">
          {t('esim_powered_by')}
        </p>
      </CardContent>
    </Card>
  );
};

export default EsimCard;
